import apiClient from "./ApiService";
import { PATH_MARITAL } from "../config/env";

export const getMaritalStatus = async()=>{
    return await apiClient.get(PATH_MARITAL);
}

export default getMaritalStatus;